const metaServiceRepo = {
  getTermConditionList() {
    return Promise.resolve({
      json: () => {
        return Promise.resolve(sampleTermsAndConditionsList)
      }
    })
  },
}

const sampleTermsAndConditionsList = [
  {
    svcType: 'GD' ,// 일반 컨시어지디바이스
    req: true,
    svcToaId: 'requiredForUPlusService',
    svcToaNm: 'LG유플러스 서비스 이용약관 동의 (필수)',
    svcToaCntn: 'LG유플러스 서비스 이용약관 동의 (필수) - 내용',
    svcToaFileNm: '~/html/appl/agree1.html,~/html/appl/agree1_cdevice.html'
  },
  {
    svcType: 'G' ,//컨시어지디바이스 원래는 svcType: 'D' 였으나 privacy센터 필수항목으로 변경
    req: true,
    svcToaId: 'requiredForConciergeDeviceOnlyOneInformation',
    svcToaNm: '고유식별 정보 수집, 이용 동의 (필수)',
    svcToaCntn: '컨시어지 디바이스 용 약관동의 ',
    svcToaFileNm: '~/html/appl/agree2_cdevice.html'
  },

  {
    svcType: 'G' ,//일반
    req: true,
    svcToaId: 'requiredForPersonalInformation',
    svcToaNm: '개인정보 수집 이용동의 (필수)',
    svcToaCntn: '개인정보 수집 이용동의 (필수) - 내용',
    svcToaFileNm: '~/html/appl/agree2.html,~/html/appl/agree2_SM_N930L.html'
  },
  {
    svcType: 'G' ,//일반
    req: true,
    svcToaId: 'requiredForPersonalLocationInformation',
    svcToaNm: '개인위치 정보 수집,이용동의 (필수)',
    svcToaCntn: '개인위치 정보 수집,이용동의 (필수) - 내용',
    svcToaFileNm: '~/html/appl/agree_personal_location.html'
  },
  {
    svcType: 'G' ,//일반
    req: true,
    svcToaId: 'requiredForServiceProviding',
    svcToaNm: '서비스 제공을 위한 개인정보 제공 이전 동의 (필수)',
    svcToaCntn: '서비스 제공을 위한 개인정보 제공 이전 동의 (필수) - 내용',
    svcToaFileNm: '~/html/appl/longdesc_agree7.html'
  },
  {
    svcType: 'GD' ,//둘다
    req: true,
    svcToaId: 'requiredForCreditInformation',
    svcToaNm: '신용정보 조회에 관한 동의 (필수)',
    svcToaCntn: '신용정보 조회에 관한 동의 (필수) - 내용',
    svcToaFileNm: '~/html/appl/agree11.html ,~/html/appl/agree3_cdevice.html'
  },
  {
    svcType: 'D' ,//컨시어지디바이스
    req: true,
    svcToaId: 'requiredForConciergeDeviceSaleUse',
    svcToaNm: '단말기 매매 및 의무사용 약정 인수 약정조항 (필수)',
    svcToaCntn: ' 컨시어지 디바이스 용 약관동의 ',
    svcToaFileNm: '~/html/appl/agree4_cdevice.html'
  },
  //24.05.02 약관내용 변경 
  {
    svcType: 'G' ,//일반
    req: false,
    svcToaId: 'optionalMarketingOffer',
    //svcToaNm: '고객혜택정보/광고정보 제공을 위한 동의 (마케팅 활용동의)(선택)',
    //svcToaCntn: '고객 혜택정보/광고 정보 제공을 위한 동의 (마케팅 활용동의)(선택) ',
    svcToaNm: '고객 혜택정보 제공을 위한 정보 수집 ·이용 동의',
    svcToaCntn: '고객 혜택정보 제공을 위한 정보 수집 ·이용 동의',
    svcToaFileNm: '~/html/appl/agree8.html'
  },

  // 마케팅 활용동의에 대하여 선택적으로 동의를 받고 있으나. SMS, 이메일, 앱푸시 등 분리하여 동의를 받지 않고 있음 //24.05.02 약관내용 변경 
  {
    svcType: 'G' ,//일반
    req: false,
    svcToaId: 'optionalMarketingOfferPersonal',
    //svcToaNm: '고객혜택정보/광고 정보제공을 위한 개인정보처리위탁 동의 (마케팅 활용동의)(선택)',
    //svcToaCntn: '고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 동의 (마케팅 활용동의)(선택)',
    svcToaNm: '혜택정보 · 광고 수신 동의',
    svcToaCntn: '혜택정보 · 광고 수신 동의',
    svcToaFileNm: '~/html/appl/agree10.html'
  },
  {
    svcType: 'G' ,//일반
    req: false,
    svcToaId: 'optionalMarketingOfferAds',
    svcToaNm: '광고전송 동의 (마케팅 활용동의)(선택)',
    svcToaCntn: '고객 혜택정보/광고 정보 제공을 위한 동의 (마케팅 활용동의)(선택) ',
    svcToaFileNm: '~/html/appl/agree9.html'
  },
  //24.05.02 약관내용 추가 
  {
    svcType: 'G' ,//일반
    req: false,
    svcToaId: 'optionalMarketingOfferPersonalTrst',
    svcToaNm: '고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 안내',
    svcToaCntn: '고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 안내',
    svcToaFileNm: '~/html/appl/agree16.html'
  },  
  {
    svcType: 'R' ,//라우터
    req: true,
    svcToaId: 'requiredForMobileRouter',
    svcToaNm: '모바일라우터 의무약정 조항 (필수)',
    svcToaCntn: '모바일라우터 의무약정 조항 (필수)을 안내하는 표',
    svcToaFileNm: '~/html/appl/agree5_router.html'
  },
  {
    svcType: 'T' ,//번호이동(T)
    req: true,
    svcToaId: 'requiredForMobileMove',
    svcToaNm: '번호 이동 신청 동의 (필수)',
    svcToaCntn: '번호 이동 신청 동의 (필수)',
    svcToaFileNm: '~/html/appl/agree3.html'
  },
  {
    svcType: 'CR' ,//기변(C) 재가입(R)
    req: true,
    svcToaId: 'requiredForMobileFeeSupport',
    svcToaNm: '휴대폰 구입 비용 지원 신청 동의 (필수)',
    svcToaCntn: '휴대폰 구입 비용 지원 신청 동의 (필수)',
    svcToaFileNm: '~/html/appl/agree4.html'
  },
  {
    svcType: 'D' ,//컨시어지디바이스
    req: true,
    svcToaId: 'requiredForConciergeDeviceInstallment',
    svcToaNm: '단말기 할부계약 약정 조항 (필수)',
    svcToaCntn: '컨시어지 디바이스 용 약관동의',
    svcToaFileNm: '~/html/appl/agree5_cdevice.html'
  },
  {
    svcType: 'G' ,
    req: true,
    svcToaId: 'requiredForMobileInstallment',
    svcToaNm: '휴대폰 할부계약 약정조항 (필수)',
    svcToaCntn: '휴대폰 할부계약 약정조항 (필수)',
    svcToaFileNm: '~/html/appl/agree5.html'
  },
  {
    svcType: 'D' ,//컨시어지디바이스
    req: true,
    svcToaId: 'requiredForLocationServiceInformationOffer',
    svcToaNm: '위치 기반 서비스 정보 제공 및 동의 (필수)',
    svcToaCntn: '컨시어지 디바이스 용 약관동의',
    svcToaFileNm: '~/html/appl/agree6_cdevice.html'
  },
  {
    svcType: 'A' ,//아시아나
    req: true,
    svcToaId: 'requiredForAsianaMileage',
    svcToaNm: '개인정보 수집 이용 동의서(사은품 발송 및 경품행사용) (필수)',
    svcToaCntn: '아시아나 마일리지 (필수) ',
    svcToaFileNm: '~/html/appl/agree_asiana.html'
  },
]

export {metaServiceRepo}
